<style lang="scss" scoped>
.app-main {
  width: 100%;
  height: 100%;
  padding: 18px 30px 30px 30px;
  box-sizing: border-box;
  overflow-y: auto;
}
</style>
<template>
  <div class="app-main">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'appMain'
};
</script>